
import React from 'react';

import { Container, Grid, Typography, makeStyles, Theme, createStyles, Card, CardHeader, CardContent, CardActions, Button } from "@material-ui/core";

import StarIcon from '@material-ui/icons/StarBorder';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
        '@global': {
            ul: {
            margin: 0,
            padding: 0,
            listStyle: 'none',
            },
        },      
        cardHeader: {
            backgroundColor:
                theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
        },
        cardPricing: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'baseline',
            marginBottom: theme.spacing(2),
        },
        list: {
          justifyContent: "center",
        },
        root: {
         display: "flex",
          flexDirection: "row",
        }
  }),
);


const OtherPlans: React.FC = () => {

    const classes = useStyles();

    const tiers = [
        {
          title: 'Code Only',
          price: '50',
          description: [
                '20 code interviews/month ', 
                '+$3 per interview', 
                'Email support',
            ],
          buttonText: 'Get started',
          buttonVariant: 'outlined',
        },
        {
          title: 'ISV/Partner',
          price: '250',
          description: [
            '100 interviews/month*',
            '+$3 additional interview',
            'Priority email support',
          ],
          buttonText: 'Get started',
          buttonVariant: 'outlined',
        },
      ];
 
    return  (<>
        <Container maxWidth="lg" component="main" className={classes.root} >

            <Grid container spacing={5} alignItems="center"  className={classes.list}>
            {tiers.map((tier) => (
                // Enterprise card is full width at sm breakpoint
                <Grid item key={tier.title} xs={12} sm={tier.title === 'Enterprise' ? 12 : 6} md={3}>
                <Card>
                    <CardHeader
                    title={tier.title}
                    titleTypographyProps={{ align: 'center' }}
                    subheaderTypographyProps={{ align: 'center' }}
                    action={tier.title === 'Pro' ? <StarIcon /> : null}
                    className={classes.cardHeader}
                    />
                    <CardContent>
                    <div className={classes.cardPricing}>
                        <Typography component="h2" variant="h3" color="textPrimary">
                        ${tier.price}
                        </Typography>
                        <Typography variant="h6" color="textSecondary">
                        /month
                        </Typography>
                    </div>
                    <ul>
                        {tier.description.map((line) => (
                        <Typography component="li" variant="subtitle1" align="center" key={line}>
                            {line}
                        </Typography>
                        ))}
                    </ul>
                    </CardContent>
                    <CardActions>
                    <Button fullWidth variant={tier.buttonVariant as any} color="primary">
                        {tier.buttonText}
                    </Button>
                    </CardActions>
                </Card>
                </Grid>
            ))}
            </Grid>
        </Container>
    </>);

}

export default OtherPlans;


